// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","532":"styles","883":"component---src-pages-404-js"}[chunkId] + "-" + {"230":"96387ebc4f5e93931366","532":"7cb5d2f43680895bf322","883":"4055ca583b487d4d2a8d"}[chunkId] + ".js";
};